export const initialState = {
    faqsList: null,
    activeFaqs:null
  };